import { createClient } from "@supabase/supabase-js";

import { createAuth } from "@redwoodjs/auth-supabase-web";

export const supabaseClient = createClient(
  process.env.SUPABASE_URL || "",
  process.env.SUPABASE_KEY || ""
);

/**
 * Ends only the session stored in this browser.
 *
 * Supabase's JavaScript client defaults to global sign-out, which would revoke
 * every session belonging to an impersonated customer. Local sign-out clears
 * this browser without disrupting the customer's own devices.
 */
export const logOutLocally = async () => {
  const { error } = await supabaseClient.auth.signOut({ scope: "local" });
  if (error) throw error;
};

export const { AuthProvider, useAuth } = createAuth(supabaseClient);
